import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getDocs, query, where, collection, onSnapshot, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import product_icon from "../assets/product_icon.png";
import { IoReceiptOutline } from "react-icons/io5";
import Loading from "../components_root/loading.jsx";
import Company_data from './company_data.jsx';
import Staff_Accounts_master from "./staff_account_root/staff_accounts.jsx";
import { TbWindowMaximize, TbWindowMinimize } from "react-icons/tb";
import { VscDashboard } from "react-icons/vsc";
import Log_history from '../log_history_root/log_history.jsx';
import Accounts_company from "./accounts_root/accounts_company.jsx";
import Staff_accounts_edit from "./staff_account_root/staff_accounts_edit.jsx";
import { MdAccountCircle, MdHistory, MdOutlineAccountCircle, MdSettings, MdPayment, MdOutlineAdminPanelSettings } from "react-icons/md";
import { FaRegAddressCard } from "react-icons/fa";
import Payment_data from "./payment_root/payment_data.jsx";
import { Get_company_information } from "./get_company_information.js";
import Settings_company_data from "./settings_company_data.jsx";
import Manage_data from "./manage_data.jsx";
import { Verify_stafftype_account } from "./staff_account_root/verify_stafftype_account.js";
export default function Company_menu() {
    const [vouchers_masterdata, setVouchers_masterdata] = useState([]);
    const [IsLoading2, setIsLoading2] = useState(true);
    const servicetablename = "accountingfinancedb";
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("company");
    const [search, setSearch] = useState(window.location.search);
    const [categorynameTab, setCategorynameTab] = useState("company");
    const [collapsed, setCollapsed] = useState(false);
    const [companyData, setCompanyData] = useState(null);
    useEffect(() => {
        const loadCompany = async () => {
            const res = await Get_company_information("company");
            if (res.success) {
                setCompanyData(res.data);
            }
        };

        loadCompany();
    }, []);
    //staff account verify
    const [checking, setChecking] = useState(true);
    const [staffstatus, setStaffstatus] = useState(false);
    const [staffdata, setStaffdata] = useState([]);
    useEffect(() => {

        const verifyStaffAccount = async () => {
            const accountguid = Cookies.get("guid");
            const result = await Verify_stafftype_account(accountguid);
            if (result.success) {

                if (result.data.administration_login == false) {
                    navigate("/staff");
                    return;
                }

                setStaffdata({
                    staff: result.data,
                    accountinfo: result.accountinfo
                });
                setStaffstatus(true);
                setChecking(false);
            } else {
                setChecking(true);
            }
        };
        verifyStaffAccount();
    }, []);
 



    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("company");
        }
    }, [search]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        // Run once on mount
        handleResize();

        // Attach resize listener
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const updateSearch = () => setSearch(window.location.search);

        window.addEventListener("popstate", updateSearch);

        // Patch replaceState and pushState
        const patchHistory = (method) => {
            const original = window.history[method];
            window.history[method] = function () {
                const result = original.apply(this, arguments);
                window.dispatchEvent(new Event("urlchange"));
                return result;
            };
        };

        patchHistory("replaceState");
        patchHistory("pushState");

        window.addEventListener("urlchange", updateSearch);

        return () => {
            window.removeEventListener("popstate", updateSearch);
            window.removeEventListener("urlchange", updateSearch);
        };
    }, []);
    const Pages = {
        company: Company_data,
        staff_accounts_edit: Staff_accounts_edit,
        "log-history": Log_history,
        "staff-accounts": Staff_Accounts_master, 
        "payment": Payment_data,
        "settings": Settings_company_data,
        "manage": Manage_data,
    };
    const setcategoryproductsTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
    };
    const ActivePage = Pages[categorynameTab] || null;
    const openEditVoucher = (uid) => {
        navigate(`/accounting?page=voucher&voucher_name=${uid}`, {
            state: { accountguid: uid }
        });
    };

        // ✅ SAFE
if (checking) {
    return (
        <div className="container_roots">
            <Loading />
        </div>
    );
}
    return (
        <div>
            <div className="products-body">
                <div className="productsmenu " >
                    <div onClick={() => setCollapsed(!collapsed)} className={`menu-div b-bottom p-1 ${activeTab === "editcompany" ? "activemenu" : ""}`}  >
                        <table>
                            <tr>
                                <td width={40}   >
                                    <div className="menu-btn" >
                                        {collapsed ? <TbWindowMaximize className="icon-img" /> : <TbWindowMinimize className="icon-img" />}

                                    </div>
                                </td>
                                <td>
                                    {!collapsed && (

                                        <div className="menu-title bold text-h2 fcap"
                                        >
                                            Company
                                        </div>
                                    )}
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div title="Dashboard" className={`ui-items cursor p-1 ${categorynameTab === "company" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("company");
                            setcategoryproductsTabInUrl("company");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><VscDashboard className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="productsmenu-pc text-h2 fcap">
                                            <>Dashboard</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Dashboard
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>
                    </div>

                    <div title="Log History" className={`ui-items cursor p-1 ${categorynameTab === "log-history" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("log-history");
                            setcategoryproductsTabInUrl("log-history");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdHistory className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Log History</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Log
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                    <div title="Settings" className={`ui-items cursor p-1 ${categorynameTab === "settings" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("settings");
                            setcategoryproductsTabInUrl("settings");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdOutlineAdminPanelSettings className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Settings</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Log
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                    <div title="Staff Accounts" className={`ui-items cursor p-1 ${categorynameTab === "staff-accounts" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("staff-accounts");
                            setcategoryproductsTabInUrl("staff-accounts");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><FaRegAddressCard className="icon-img" /></td>


                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Staff Accounts</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Staff
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
                    <div title="Payment" className={`ui-items cursor p-1 ${categorynameTab === "payment" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => {
                            setCategorynameTab("payment");
                            setcategoryproductsTabInUrl("payment");
                        }}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={50} className="items-center"><MdPayment className="icon-img" /></td>
                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            <>Payment setting</>
                                        </td>
                                    )}

                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Payment
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>

                    </div>
        
                    <div title="Reports" className={`ui-items cursor  p-1 menunonemenu items-back-fill " : " menunonemenu"}`}

                        onClick={() => navigate("/company")}
                    >
                        <table>
                            <tbody>
                                <tr>
                                    <td width={30} ><MdSettings className="icon-img" /></td>

                                    {collapsed === false && (
                                        <td className="text-h2 fcap">
                                            {companyData?.company.substring(0, 20) || "N/A"}
                                        </td>
                                    )}
                                </tr>

                                {collapsed === true &&
                                    (<tr>
                                        <td width={40} className="fcap text-h3 text-off">
                                            Settings
                                        </td>
                                    </tr>
                                    )}

                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="products-container">
                    {ActivePage && <ActivePage />}
                </div>

            </div>
        </div>
    );
}
